import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class FlagService {
  constructor() {}

  flagServiceObject = [
    {ageJunctureFlag: true},
    {offerJunctureFlag: false},
    {familyJunctureFlag: false},
    {userdataJunctureFlag: false},
    {socsecurityJunctureFlag: false},
    {contactinfoJunctureFlag: false},
    {payfrequencyJunctureFlag: false},
    {conditionsJunctureFlag: false},
    {captchaJunctureFlag: false},

    {finalpaymentJunctureFlag: false},
  ];

  public bannerVisible = true;
}
